import { FC } from 'react';

import { IconProps } from '.';

export const PdfFileIcon: FC<IconProps> = ({ width = 32, height = 32 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5 3.334v25.333a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V8.242a1 1 0 0 0-.264-.677l-5.439-5.909a1 1 0 0 0-.736-.322H7.5a2 2 0 0 0-2 2"
      fill="#FFC8AB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5 6.833a1.1 1.1 0 0 1-1.1 1.1H9.6a1.1 1.1 0 0 1 0-2.2h6.8a1.1 1.1 0 0 1 1.1 1.1m6 5.867a1.1 1.1 0 0 1-1.1 1.1H9.6a1.1 1.1 0 0 1 0-2.2h12.8a1.1 1.1 0 0 1 1.1 1.1"
      fill="#FFF7ED"
    />
    <path
      d="M27 16.61H4v8.657a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V17.61a1 1 0 0 0-1-1"
      fill="#F97316"
    />
    <path d="M5.5 15 4 16.61h1.5z" fill="#A66A02" />
    <path
      d="M9.663 24v-5.09h1.909q.587 0 .984.218.4.22.604.602.207.38.207.865 0 .489-.207.87-.206.38-.609.6-.402.215-.992.215h-1.265v-.758h1.141q.343 0 .562-.12a.75.75 0 0 0 .323-.327q.107-.21.107-.48t-.107-.477a.73.73 0 0 0-.325-.321 1.2 1.2 0 0 0-.565-.117h-.845V24zm6.23 0h-1.725v-5.09h1.76q.758 0 1.302.305.547.304.84.873.294.57.294 1.362 0 .795-.296 1.367a2.04 2.04 0 0 1-.848.878q-.552.305-1.327.305m-.803-.797h.758q.532 0 .887-.194a1.24 1.24 0 0 0 .535-.585q.18-.39.179-.974 0-.584-.18-.97a1.22 1.22 0 0 0-.528-.579q-.348-.194-.866-.194h-.785zm4.15.797v-5.09h3.26v.773h-2.339v1.382h2.116v.773h-2.116V24z"
      fill="#fff"
    />
  </svg>
);
